import React from 'react';
import { FormApi } from 'final-form';
import DateRangeFields from './DateRangeFields';
import RegionFilterFields from './RegionFilterFields';
import styles from './ReportList.module.scss';
import CustomTooltip from '../../components/tooltip';
import ResetIcon from '../../assets/images/reset.svg';
import toastCenter from '../../utils/toastCenter';
import APPCONSTANTS from '../../constants/appConstants';
import { ISKFiltersFormValues, validateSKReportFilters } from './SKReport';
import { useSelector } from 'react-redux';
import { skReportLoadingSelector } from '../../store/report/selectors';

interface ISKFilterFieldsProps {
  form: FormApi<any>;
  name: string;
  values: any;
  rowsPerPage?: number;
  onFetchSKReport?: (formValues: ISKFiltersFormValues, page: number, rowsPerPage: number) => void;
}

const SKFilterFields = ({
  form,
  name = 'skreport',
  values,
  rowsPerPage = APPCONSTANTS.ROWS_PER_PAGE_OF_TABLE,
  onFetchSKReport
}: ISKFilterFieldsProps): React.ReactElement => {
  const skReportLoading = useSelector(skReportLoadingSelector);
  const fieldName = (field: keyof ISKFiltersFormValues) => `${name}.${field}`;
  const formValues: ISKFiltersFormValues = values?.[name] ?? {};

  const handleResetRegionFilters = () => {
    const current = values?.[name] ?? {};
    form.change(name, {
      ...current,
      fromDate: undefined,
      toDate: undefined,
      division: null,
      district: null,
      upazila: null
    });
  };

  const handleViewReport = () => {
    if (!validateSKReportFilters(formValues)) {
      toastCenter.error(APPCONSTANTS.ERROR, APPCONSTANTS.SK_REPORT_FILTER_VALIDATION_ERROR);
      return;
    }

    onFetchSKReport?.(formValues, APPCONSTANTS.NUMBER.ONE, rowsPerPage);
  };

  return (
    <div className='col-auto'>
      <div className={`${styles.sideMenu} ${styles.customSidemenu}`}>
        <div className='d-flex justify-content-between align-items-center'>
          <div className={`card-header bg-transparent ${styles.header}`}>
            <span className={styles.headerLabel}>Filters</span>
          </div>
          <CustomTooltip title='Reset'>
            <button
              type='button'
              onClick={handleResetRegionFilters}
              className='btn p-0 border-0 bg-transparent pointer'
              aria-label='Reset filters'
            >
              <img src={ResetIcon} alt='reset-icon' />
            </button>
          </CustomTooltip>
        </div>
        <hr />
        <DateRangeFields
          form={form}
          formValues={formValues}
          fromDateFieldName={fieldName('fromDate')}
          toDateFieldName={fieldName('toDate')}
        />
        <RegionFilterFields form={form} name={name} values={values} />
        <button
          onClick={handleViewReport}
          type='button'
          className='mt-2 btn primary-btn w-100'
          disabled={skReportLoading}
        >
          {skReportLoading ? 'Loading...' : 'View Report'}
        </button>
      </div>
    </div>
  );
};

export default SKFilterFields;
